import { render, staticRenderFns } from "./PredefinedAnswersIndex.vue?vue&type=template&id=0e64b78a&"
import script from "./PredefinedAnswersIndex.vue?vue&type=script&lang=js&"
export * from "./PredefinedAnswersIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports